import { render, staticRenderFns } from "./BuildYourJewel.vue?vue&type=template&id=6865ea32&scoped=true&"
import script from "./BuildYourJewel.vue?vue&type=script&lang=js&"
export * from "./BuildYourJewel.vue?vue&type=script&lang=js&"
import style0 from "./BuildYourJewel.vue?vue&type=style&index=0&id=6865ea32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6865ea32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2065084294/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6865ea32')) {
      api.createRecord('6865ea32', component.options)
    } else {
      api.reload('6865ea32', component.options)
    }
    module.hot.accept("./BuildYourJewel.vue?vue&type=template&id=6865ea32&scoped=true&", function () {
      api.rerender('6865ea32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BuildYourJewel.vue"
export default component.exports